module.exports = __webpack_public_path__ + "static/media/bill_one.28274944.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-flight/landing/bill_one.png
// module id = 1408
// module chunks = 0